// extracted by mini-css-extract-plugin
export var exploreTrail = "Trail-module__explore_trail___ONEGG";
export var container = "Trail-module__container___joe8I";
export var trailInfoContainer = "Trail-module__trailInfoContainer___tIkam";
export var trailInfo = "Trail-module__trailInfo___Ejufa";
export var trailSidebar = "Trail-module__trailSidebar___Bsu11";
export var divider = "Trail-module__divider___Cmea4";
export var suggestEditAndDropdown = "Trail-module__suggestEditAndDropdown___yE0g3";
export var tagGroupContainer = "Trail-module__tagGroupContainer___JFhKU";
export var mobileStaticMap = "Trail-module__mobileStaticMap___r3_4z";